import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import entityComposition from '../../common/classes/entityComposition';
import OptionNestedPickerField from './optionNestedPicker/optionNestedPicker';
import Label from './label';
import { enabledSelector, newPathSelector, valueSelector } from '../selectors/index';
import logValueOnChange from '../commonActions/logValueOnChange';
import { leafPedigreesString } from '../../../../behaviors/src/lib/common';
import { removeNulls } from '../../../utils/contentTools';
const buildTree = function buildTree(list) {
  let others = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const parsedOthers = others.map(other => ({
    identifier: other.id,
    name: other.name,
    sectionName: 'Other'
  }));
  const tree = [];
  list.concat(parsedOthers).forEach(piece => {
    let parent = tree.find(existingPiece => existingPiece.title === piece.sectionName);
    if (!parent) {
      parent = {
        _created: tree.length,
        title: piece.sectionName,
        identifier: "_".concat(piece.sectionName),
        options: []
      };
      tree.push(parent);
    }
    parent.options.push({
      _created: piece.sortOrder,
      identifier: piece.identifier,
      title: piece.name
    });
  });
  return tree;
};
const PiecesPickerField = _ref => {
  let _ref$pieceComponentRe = _ref.pieceComponentReport,
    list = _ref$pieceComponentRe.list,
    initialIndexQuery = _ref$pieceComponentRe.initialIndexQuery,
    serverIndex = _ref.pieceComponentReportActions.serverIndex,
    _ref$pieceOtherCompon = _ref.pieceOtherComponent,
    otherList = _ref$pieceOtherCompon.list,
    otherInitialIndexQuery = _ref$pieceOtherCompon.initialIndexQuery,
    otherServerIndex = _ref.pieceOtherComponentActions.serverIndex,
    jobID = _ref.jobID,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? {} : _ref$value,
    onChange = _ref.onChange,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    path = _ref.path;
  const wrappedOnChange = _ref2 => {
    let tree = _ref2.value,
      changeModifiers = _ref2.changeModifiers;
    const displayValue = leafPedigreesString(removeNulls(tree));
    onChange({
      path,
      value: tree,
      displayValue,
      changeModifiers
    });
  };
  useEffect(() => {
    serverIndex(_objectSpread(_objectSpread({}, initialIndexQuery), {}, {
      jobID
    }));
    otherServerIndex(_objectSpread(_objectSpread({}, otherInitialIndexQuery), {}, {
      jobID
    }));
  }, [serverIndex, initialIndexQuery, otherServerIndex, otherInitialIndexQuery, jobID]);
  const options = useMemo(() => buildTree(list, otherList), [list, otherList]);
  return /*#__PURE__*/React.createElement("div", null, label ? /*#__PURE__*/React.createElement(Label, {
    value: label
  }) : null, /*#__PURE__*/React.createElement(OptionNestedPickerField, {
    label: label,
    options: options,
    enabled: enabled,
    value: value,
    allowsMultipleSelection: true,
    onChange: wrappedOnChange
  }));
};
PiecesPickerField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.shape({}),
  enabled: PropTypes.bool,
  jobID: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  pieceComponentReportActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  pieceComponentReport: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({})),
    initialIndexQuery: PropTypes.shape({})
  }).isRequired,
  pieceOtherComponentActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  pieceOtherComponent: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({})),
    initialIndexQuery: PropTypes.shape({})
  }).isRequired
};
export { PiecesPickerField as UncomposedPiecesPickerField };
export default entityComposition(PiecesPickerField, ['pieceComponentReport', 'pieceOtherComponent'], {
  jobID: state => state.report.active.Job.id,
  value: valueSelector,
  enabled: enabledSelector,
  path: newPathSelector,
  onChange: logValueOnChange
});